import { NgModule } from '@angular/core';
import { FilterIngPipe } from '@app/pipes/filterIng/filterIng.pipe';
import { AbsolutePathPipe } from '@app/pipes/absolute-path/absolute-path.pipe';
import { PlusPipe } from '@app/pipes/plus/plus.pipe';
import { ToArrPipe } from '@app/pipes/toArray/toArray.pipe';
import { groupByCategoryPipe } from '@app/pipes/groupByCategory/groupByCategory.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
@NgModule({
    imports: [
    ],
    declarations: [
        AbsolutePathPipe,
        PlusPipe,
        FilterIngPipe,
        groupByCategoryPipe,
        ToArrPipe,
        SafeHtmlPipe
    ],
    exports: [
        AbsolutePathPipe,
        PlusPipe,
        FilterIngPipe,
        groupByCategoryPipe,
        ToArrPipe,
        SafeHtmlPipe
    ]
})

export class PipesModule {

}
